<script setup>
import moment from "moment";
import { statusIMKPEnum } from "@/utilities/enum";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 my-5">
      <v-col cols="12">
        <div
          class="w-100 border border-1 pt-2 shadow-sm"
          style="
            min-height: 5vh;
            background-color: #f8d7da;
            border-radius: 1rem;
            overflow: hidden;
          "
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pengajuan IMKP
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div
              class="d-flex justify-content-between px-4 pt-4 align-items-end"
            >
              <div class="d-flex align-items-end">
                <img
                  src="../../assets/images/borneo-indobara-icon.png"
                  alt="logo"
                  style="width: 4rem; height: auto"
                  loading="lazy"
                />
                <h6 class="fw-bold w-100 m-0">PT BORNEO INDOBARA</h6>
              </div>
              <h6 class="fw-bold text-end text-nowrap m-0">
                BIB-HSE-PPO-F-071-01
              </h6>
            </div>
            <v-form ref="formData" class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                IZIN MELAKSANAKAN KEGIATAN PROYEK
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Sebagai persyaratan untuk melaksanakan kegiatan proyek di dalam
                area kerja PT Borneo Indobara
              </p>
              <div
                class="alert alert-warning"
                role="alert"
                v-if="status === statusIMKPEnum.NEED_REVISION"
              >
                <p class="m-0 fs-6 fw-bold">Pengajuan IMKP Ditolak</p>
                <span>Catatan :</span><br />
                <p class="m-0" style="white-space: pre-line">
                  {{ reason }}
                </p>
              </div>
              <v-btn
                color="error"
                class="mb-2 text-white font-weight-bold text-caption"
                :class="'w-25'"
                v-if="
                  status == statusIMKPEnum.IMKP_PUBLISHED ||
                  status == statusIMKPEnum.BAST_PROCESS ||
                  status == statusIMKPEnum.IMKP_DONE
                "
                @click="downloadFileEsign(documentIdImkp)"
              >
                Download Dokumen IMKP
              </v-btn>
              <p
                class="mb-4"
                style="
                  font-family: 'Inter-Thin';
                  font-size: 0.9rem;
                  letter-spacing: 0.1rem;
                  font-weight: bold;
                "
              >
                A. DETAIL IZIN
              </p>
              <div class="row mb-2">
                <div class="col-md-6">
                  <label
                    for="kontraktor"
                    class="text-xs font-medium text-gray-600"
                  >
                    Kontraktor / Subkontraktor
                  </label>
                  <v-text-field
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    disabled
                    bg-color="grey-lighten-2"
                    v-model="formValues.detailIzin.kontraktorName"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                  >
                  </v-text-field>
                  <p class="font-medium text-sm m-0 text-slate-700" v-else>
                    {{ formValues.detailIzin.kontraktorName || "-" }}
                  </p>
                </div>
                <div class="col-md-6">
                  <label
                    for="namapemegangizin"
                    class="text-xs font-medium text-gray-600"
                  >
                    Nama Pemegang Izin
                  </label>
                  <v-text-field
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    disabled
                    bg-color="grey-lighten-2"
                    v-model="formValues.detailIzin.namaPemegangIzin"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                  ></v-text-field>
                  <p class="font-medium text-sm m-0 text-slate-700" v-else>
                    {{ formValues.detailIzin.namaPemegangIzin || "-" }}
                  </p>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-3">
                  <label
                    for="lokasikerja"
                    class="text-xs font-medium text-gray-600"
                  >
                    Lokasi Kerja
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    v-model="formValues.detailIzin.lokasiKerja"
                    :items="listLokasi"
                    item-title="location_name"
                    item-value="id"
                    color="#475569"
                    return-object
                    :rules="formValidasi.lokasiKerja"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                    @input="getLocation($event)"
                  ></v-autocomplete>
                  <p class="font-medium text-sm m-0 text-slate-700" v-else>
                    {{ formValues.detailIzin.lokasiKerja || "-" }}
                  </p>
                </div>
                <div class="col-md-3">
                  <label
                    for="subLokasi"
                    class="text-xs font-medium text-gray-600"
                  >
                    Sub Lokasi Kerja
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    v-model="formValues.detailIzin.subLokasiKerja"
                    :items="listSubLokasi"
                    item-title="name"
                    item-value="id"
                    color="#475569"
                    multiple
                    chips
                    closable-chips
                    return-object
                    :rules="formValidasi.subLokasiKerja"
                    :disabled="!formValues.detailIzin.lokasiKerja"
                    :bg-color="
                      !formValues.detailIzin.lokasiKerja ? 'grey-lighten-2' : ''
                    "
                    :loading="isLoadingSubLokasi"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                  ></v-autocomplete>
                  <p class="font-medium text-sm m-0 text-slate-700" v-else>
                    {{ formatSubLokasiDisplay(formValues.detailIzin.subLokasiKerja) }}
                  </p>
                </div>
                <div class="col-md-6">
                  <label
                    for="judulproyek"
                    class="text-xs font-medium text-gray-600"
                  >
                    Keterangan Lokasi Proyek
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-text-field
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    color="#475569"
                    :rules="formValidasi.keteranganLokasiKerja"
                    v-model="formValues.detailIzin.keteranganLokasiKerja"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                  ></v-text-field>
                  <p class="font-medium text-sm m-0 text-slate-700" v-else>
                    {{ formValues.detailIzin.keteranganLokasiKerja || "-" }}
                  </p>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <label
                    for="judulproyek"
                    class="text-xs font-medium text-gray-600"
                  >
                    Judul Proyek
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-text-field
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    color="#475569"
                    v-model="formValues.detailIzin.judulProyek"
                    :rules="formValidasi.judulProyek"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                  ></v-text-field>
                  <p class="font-medium text-sm m-0 text-slate-700" v-else>
                    {{ formValues.detailIzin.judulProyek || "-" }}
                  </p>
                </div>
                <div class="col-md-6">
                  <label
                    for="nomorizin"
                    class="text-xs font-medium text-gray-600"
                  >
                    Nomor Izin
                  </label>
                  <v-text-field
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    disabled
                    bg-color="grey-lighten-2"
                    v-model="formValues.detailIzin.nomorizin"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                  >
                  </v-text-field>
                  <p class="font-medium text-sm m-0 text-slate-700" v-else>
                    {{ formValues.detailIzin.nomorizin || "-" }}
                  </p>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-md-3">
                  <label
                    for="lokasikerja"
                    class="text-xs font-medium text-gray-600"
                  >
                    Mulai Pekerjaan
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-date-input
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    color="#475569"
                    prepend-icon=""
                    :rules="formValidasi.mulaiPekerjaan"
                    v-model="formValues.detailIzin.mulaiPekerjaan"
                    :max="formValues.detailIzin.selesaiPekerjaan"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                  >
                  </v-date-input>
                  <p class="font-medium text-sm m-0 text-slate-700" v-else>
                    {{
                      formValues.detailIzin.mulaiPekerjaan
                        ? moment(
                            new Date(formValues.detailIzin.mulaiPekerjaan)
                          ).format("DD MMMM YYYY")
                        : "-"
                    }}
                  </p>
                </div>
                <div class="col-md-3">
                  <label
                    for="judulproyek"
                    class="text-xs font-medium text-gray-600"
                  >
                    Selesai Pekerjaan
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-date-input
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    color="#475569"
                    prepend-icon=""
                    :rules="formValidasi.selesaiPekerjaan"
                    v-model="formValues.detailIzin.selesaiPekerjaan"
                    :min="formValues.detailIzin.mulaiPekerjaan"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                  >
                  </v-date-input>
                  <p class="font-medium text-sm m-0 text-slate-700" v-else>
                    {{
                      formValues.detailIzin.selesaiPekerjaan
                        ? moment(
                            new Date(formValues.detailIzin.selesaiPekerjaan)
                          ).format("DD MMMM YYYY")
                        : "-"
                    }}
                  </p>
                </div>
                <div class="col-md-3">
                  <label
                    for="durasiPekerjaan"
                    class="text-xs font-medium text-gray-600"
                  >
                    Durasi Pekerjaan
                  </label>
                  <p
                    class="font-medium text-sm text-slate-700"
                    :class="{
                      'pt-3':
                        status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION,
                    }"
                  >
                    {{
                      formValues.detailIzin.durasi
                        ? formValues.detailIzin.durasi + " Hari"
                        : "-"
                    }}
                  </p>
                </div>
              </div>
              <p
                class="mb-4"
                style="
                  font-family: 'Inter-Thin';
                  font-size: 0.9rem;
                  letter-spacing: 0.1rem;
                  font-weight: bold;
                "
              >
                B. DETAIL PEKERJAAN
              </p>

              <div class="row mb-5">
                <div class="col-md-12">
                  <label
                    for="uraianPekerjaan"
                    class="text-xs font-medium text-gray-600"
                  >
                    Uraian Pekerjaan
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-textarea
                    variant="outlined"
                    density="compact"
                    color="#475569"
                    :rules="formValidasi.uraianPekerjaan"
                    auto-grow
                    rows="7"
                    v-model="formValues.detailPekerjaan.uraianPekerjaan"
                    placeholder="Masukkan uraian pekerjaan"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                    maxlength="1000"
                    hide-details="auto"
                  ></v-textarea>
                  <p
                    class="font-medium text-sm m-0 text-slate-700"
                    style="
                      white-space: pre-line;
                      word-break: break-word;
                      overflow-wrap: break-word;
                    "
                    v-else
                  >
                    {{ formValues.detailPekerjaan.uraianPekerjaan }}
                  </p>
                  <div
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                    class="d-flex justify-content-end gap-3"
                  >
                    <p class="text-xs font-normal italic text-gray-500">
                      {{ messageUraianPekerjaan?.panjang ?? 0 }}/1000 karakter
                      atau {{ messageUraianPekerjaan?.lineCount ?? 0 }}/9 baris
                      (1 baris berisi 115 karakter)
                    </p>
                  </div>
                </div>
              </div>

              <p
                class="mb-4"
                style="
                  font-family: 'Inter-Thin';
                  font-size: 0.9rem;
                  letter-spacing: 0.1rem;
                  font-weight: bold;
                "
              >
                C. PENCEGAHAN / PERSYARATAN KHUSUS
              </p>
              <div
                class="row border p-2"
                style="
                  margin-left: 0;
                  margin-right: 0;
                  background-color: #f2f2f5;
                "
              >
                <div class="col-md-4 font-medium text-sm">Daftar Periksa</div>
                <div class="col-md-1 text-center font-medium text-sm">Y</div>
                <div class="col-md-1 text-center font-medium text-sm">T</div>
                <div class="col-md-4 font-medium text-sm">Daftar Periksa</div>
                <div class="col-md-1 text-center font-medium text-sm">Y</div>
                <div class="col-md-1 text-center font-medium text-sm">T</div>
              </div>
              <div
                class="row border p-2 text-sm font-normal"
                style="margin-left: 0; margin-right: 0"
              >
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q1?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q1?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q1,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q1?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q1?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q1,
                    }"
                  >
                    Kontrak / PO / NOA / SI
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q1?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q1?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Kontrak / PO / NOA / SI',
                        formValues.persyaratanKhusus.assets_c_q1
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q1"
                    v-model="formValues.persyaratanKhusus.c_q1"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q1"
                    v-model="formValues.persyaratanKhusus.c_q1"
                    disabled
                  />
                </div>
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q8?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q8?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q8,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q8?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q8?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q8,
                    }"
                  >
                    HSE Plan (Inspeksi, Safety Talk, Observasi & pelatihan
                    keselamatan (Emergency Drill))
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q8?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q8?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'HSE Plan (Inspeksi, Safety Talk, Observasi & pelatihan keselamatan (Emergency Drill))',
                        formValues.persyaratanKhusus.assets_c_q8
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q8"
                    v-model="formValues.persyaratanKhusus.c_q8"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q8"
                    v-model="formValues.persyaratanKhusus.c_q8"
                    disabled
                  />
                </div>
              </div>
              <div
                class="row border p-2 text-sm font-normal"
                style="
                  margin-left: 0;
                  margin-right: 0;
                  background-color: #f2f2f5;
                "
              >
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q2?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q2?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q2,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q2?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q2?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q2,
                    }"
                  >
                    Daftar dokumen legal perusahaan (IUJP/SIUP/IUJK) dan CoC
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q2?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q2?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Daftar dokumen legal perusahaan (IUJP/SIUP/IUJK) dan CoC',
                        formValues.persyaratanKhusus.assets_c_q2
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q2"
                    v-model="formValues.persyaratanKhusus.c_q2"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q2"
                    v-model="formValues.persyaratanKhusus.c_q2"
                    disabled
                  />
                </div>
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q9?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q9?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q9,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q9?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q9?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q9,
                    }"
                  >
                    Manajemen Perubahan (MOC)
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q9?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q9?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Manajemen Perubahan (MOC)',
                        formValues.persyaratanKhusus.assets_c_q9
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class="cursor-pointer"
                    type="radio"
                    value="Y"
                    id="c_q9"
                    v-model="formValues.persyaratanKhusus.c_q9"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class="cursor-pointer"
                    type="radio"
                    value="T"
                    id="c_q9"
                    v-model="formValues.persyaratanKhusus.c_q9"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
              </div>
              <div
                class="row border p-2 text-sm font-normal"
                style="margin-left: 0; margin-right: 0"
              >
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q3?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q3?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q3,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q3?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q3?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q3,
                    }"
                  >
                    Metode Kerja
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q3?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q3?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Metode Kerja',
                        formValues.persyaratanKhusus.assets_c_q3
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q3"
                    v-model="formValues.persyaratanKhusus.c_q3"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q3"
                    v-model="formValues.persyaratanKhusus.c_q3"
                    disabled
                  />
                </div>
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q10
                          ?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q10?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q10,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q10?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q10?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q10,
                    }"
                  >
                    Water Management Plan
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q10?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q10?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Water Management Plan',
                        formValues.persyaratanKhusus.assets_c_q10
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class="cursor-pointer"
                    type="radio"
                    value="Y"
                    id="c_q10"
                    v-model="formValues.persyaratanKhusus.c_q10"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class="cursor-pointer"
                    type="radio"
                    value="T"
                    id="c_q10"
                    v-model="formValues.persyaratanKhusus.c_q10"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
              </div>
              <div
                class="row border p-2 text-sm font-normal"
                style="
                  margin-left: 0;
                  margin-right: 0;
                  background-color: #f2f2f5;
                "
              >
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q4?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q4?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q4,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q4?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q4?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q4,
                    }"
                  >
                    Identifikasi Bahaya dan Pengendalian Resiko
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q4?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q4?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Identifikasi Bahaya dan Pengendalian Resiko',
                        formValues.persyaratanKhusus.assets_c_q4
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q4"
                    v-model="formValues.persyaratanKhusus.c_q4"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q4"
                    v-model="formValues.persyaratanKhusus.c_q4"
                    disabled
                  />
                </div>
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q11
                          ?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q11?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q11,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q11?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q11?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q11,
                    }"
                  >
                    Hydrocarbon Management Plan
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q11?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q11?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Hydrocarbon Management Plan',
                        formValues.persyaratanKhusus.assets_c_q11
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class="cursor-pointer"
                    type="radio"
                    value="Y"
                    id="c_q11"
                    v-model="formValues.persyaratanKhusus.c_q11"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class="cursor-pointer"
                    type="radio"
                    value="T"
                    id="c_q11"
                    v-model="formValues.persyaratanKhusus.c_q11"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
              </div>
              <div
                class="row border p-2 text-sm font-normal"
                style="margin-left: 0; margin-right: 0"
              >
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q5?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q5?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q5,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q5?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q5?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q5,
                    }"
                  >
                    Daftar pekerja dan lampirkan bukti kompetensi, sertifikat
                    dll
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q5?.isVerified
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Daftar pekerja dan lampirkan bukti kompetensi, sertifikat dll',
                        formValues.persyaratanKhusus.assets_c_q5
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q5"
                    v-model="formValues.persyaratanKhusus.c_q5"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q5"
                    v-model="formValues.persyaratanKhusus.c_q5"
                    disabled
                  />
                </div>
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q12
                          ?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q12?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q12,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q12?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q12?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q12,
                    }"
                  >
                    Emergency Response Plan
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q12?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q12?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Emergency Response Plan',
                        formValues.persyaratanKhusus.assets_c_q12
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q12"
                    v-model="formValues.persyaratanKhusus.c_q12"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q12"
                    v-model="formValues.persyaratanKhusus.c_q12"
                    disabled
                  />
                </div>
              </div>
              <div
                class="row border p-2 text-sm font-normal"
                style="
                  margin-left: 0;
                  margin-right: 0;
                  background-color: #f2f2f5;
                "
              >
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q6?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q6?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q6,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q6?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q6?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q6,
                    }"
                  >
                    Daftar sarana prasarana instalasi dan peralatan dan
                    komisioning
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q6?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q6?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Daftar sarana prasarana instalasi dan peralatan dan komisioning',
                        formValues.persyaratanKhusus.assets_c_q6
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q6"
                    v-model="formValues.persyaratanKhusus.c_q6"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q6"
                    v-model="formValues.persyaratanKhusus.c_q6"
                    disabled
                  />
                </div>
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q13
                          ?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q13?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q13,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q13?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q13?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q13,
                    }"
                  >
                    Struktur Organisasi Proyek
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q13?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q13?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Struktur Organisasi Proyek',
                        formValues.persyaratanKhusus.assets_c_q13
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q13"
                    v-model="formValues.persyaratanKhusus.c_q13"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q13"
                    v-model="formValues.persyaratanKhusus.c_q13"
                    disabled
                  />
                </div>
              </div>
              <div
                class="row border p-2 text-sm font-normal"
                style="margin-left: 0; margin-right: 0"
              >
                <div class="col-md-4">
                  <p
                    class="m-0"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q7?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q7?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q7,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q7?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q7?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q7,
                    }"
                  >
                    Standar Operasional Prosedur / Analisa Kerja Aman (AKA)
                    <span class="text-danger fs-9">(wajib ada)</span>
                  </p>
                  <button
                    v-if="
                      status === statusIMKPEnum.NEED_REVISION &&
                      !formValues.persyaratanKhusus.assets_c_q7?.isVerified &&
                      formValues.persyaratanKhusus.assets_c_q7?.file?.length >=
                        1
                    "
                    type="button"
                    class="btn btn-danger mt-2"
                    @click="
                      openModal(
                        'Standar Operasional Prosedur / Analisa Kerja Aman (AKA)',
                        formValues.persyaratanKhusus.assets_c_q7
                      )
                    "
                    style="
                      --bs-btn-padding-y: 0.2rem;
                      --bs-btn-padding-x: 0.5rem;
                      --bs-btn-font-size: 0.6rem;
                    "
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-file"
                      style="color: #eeecec"
                    />
                    Catatan
                  </button>
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="Y"
                    id="c_q7"
                    v-model="formValues.persyaratanKhusus.c_q7"
                    :disabled="
                      status !== statusIMKPEnum.DRAFT &&
                      status !== statusIMKPEnum.UNDER_REVIEW &&
                      status !== statusIMKPEnum.NEED_REVISION
                    "
                  />
                </div>
                <div
                  class="col-md-1 text-center d-flex align-items-center justify-content-center"
                >
                  <input
                    class=""
                    type="radio"
                    value="T"
                    id="c_q7"
                    v-model="formValues.persyaratanKhusus.c_q7"
                    disabled
                  />
                </div>
              </div>
              <div
                class="row mb-3 border p-2 text-sm font-normal"
                style="
                  background-color: #f2f2f5;
                  margin-left: 0;
                  margin-right: 0;
                "
              >
                <div class="col-md-1 text-nowrap">Y : Ya</div>
                <div class="col-md-1 text-nowrap">T : Tidak</div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <label
                    for="tindakPencegahan"
                    class="text-xs font-medium text-gray-600"
                  >
                    Tindakan Pencegahan Lainnya
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-textarea
                    variant="outlined"
                    density="compact"
                    color="#475569"
                    auto-grow
                    rows="7"
                    v-model="formValues.persyaratanKhusus.tindakPencegahan"
                    :rules="formValidasi.tindakPencegahan"
                    placeholder="Masukkan Tindakan Pencegahan Lainnya"
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                    maxlength="650"
                    hide-details="auto"
                  ></v-textarea>
                  <p
                    class="font-medium text-sm m-0 text-slate-700"
                    v-else
                    style="
                      white-space: pre-line;
                      word-break: break-word;
                      overflow-wrap: break-word;
                    "
                  >
                    {{ formValues.persyaratanKhusus.tindakPencegahan }}
                  </p>
                  <div
                    v-if="
                      status === statusIMKPEnum.DRAFT ||
                      status === statusIMKPEnum.NEED_REVISION
                    "
                    class="d-flex justify-content-end gap-3"
                  >
                    <p class="text-xs font-normal italic text-gray-500">
                      {{ messageTindakPencegahan?.panjang ?? 0 }}/650 karakter
                      atau {{ messageTindakPencegahan?.lineCount ?? 0 }}/6 baris
                      (1 baris berisi 115 karakter)
                    </p>
                  </div>
                </div>
              </div>
              <div class="row mt-3 mb-4">
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q1 == 'Y'"
                >
                  <label
                    for="file_c_q1"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q1?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q1?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q1,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q1?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q1?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q1,
                    }"
                  >
                    File Kontrak / PO / NOA / SI (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q1"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q1"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q1?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q1', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q1.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q1.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q1.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q1.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Kontrak / PO / NOA / SI_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q2 == 'Y'"
                >
                  <label
                    for="file_c_q2"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q2?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q2?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q2,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q2?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q2?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q2,
                    }"
                  >
                    File Daftar Dokumen Legal Perusahaan (IUJP/SIUP/IUJK) dan
                    CoC (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q2"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q2"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q2?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q2', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q2.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q2.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q2.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q2.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Daftar Dokumen Legal Perusahaan
                            (IUJP/SIUP/IUJK) dan CoC_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q3 == 'Y'"
                >
                  <label
                    for="file_c_q3"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q3?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q3?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q3,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q3?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q3?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q3,
                    }"
                  >
                    File Metode Kerja (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q3"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q3"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q3?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q3', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q3.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q3.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q3.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q3.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Metode Kerja_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q4 == 'Y'"
                >
                  <label
                    for="file_c_q4"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q4?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q4?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q4,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q4?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q4?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q4,
                    }"
                  >
                    File Identifikasi Bahaya dan Pengendalian Resiko (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q4"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q4"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q4?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q4', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q4.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q4.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q4.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q4.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Identifikasi Bahaya dan Pengendalian Resiko_{{
                              index + 1
                            }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q5 == 'Y'"
                >
                  <label
                    for="file_c_q5"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q5?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q5?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q5,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q5?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q5?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q5,
                    }"
                  >
                    File Daftar pekerja dan lampiran bukti kompetensi,
                    sertifikat dll (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q5"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q5"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q5?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q5', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q5.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q5.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q5.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q5.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Daftar pekerja dan lampiran bukti kompetensi,
                            sertifikat dll_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q6 == 'Y'"
                >
                  <label
                    for="file_c_q6"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q6?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q6?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q6,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q6?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q6?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q6,
                    }"
                  >
                    File Daftar sarana prasarana instalasi dan peralatan dan
                    komisioning (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q6"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q6"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q6?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q6', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q6.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q6.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q6.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q6.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Daftar sarana prasarana instalasi dan peralatan
                            dan komisioning_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q7 == 'Y'"
                >
                  <label
                    for="file_c_q7"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q7?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q7?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q7,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q7?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q7?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q7,
                    }"
                  >
                    File Standar Operasional Prosedur / Analisa Kerja Aman (AKA)
                    (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q7"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q7"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q7?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q7', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q7.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q7.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q7.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q7.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Standar Operasional Prosedur / Analisa Kerja
                            Aman (AKA)_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q8 == 'Y'"
                >
                  <label
                    for="file_c_q8"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q8?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q8?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q8,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q8?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q8?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q8,
                    }"
                  >
                    File HSE Plan (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q8"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q8"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q8?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q8', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q8.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q8.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q8.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q8.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File HSE Plan_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q9 == 'Y'"
                >
                  <label
                    for="file_c_q9"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q9?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q9?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q9,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q9?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q9?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q9,
                    }"
                  >
                    File Manajemen Perubahan (MOC) (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q9"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q9"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q9?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q9', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q9.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q9.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q9.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q9.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Manajemen Perubahan (MOC)_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q10 == 'Y'"
                >
                  <label
                    for="file_c_q10"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q10
                          ?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q10?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q10,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q10?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q10?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q10,
                    }"
                  >
                    File Water Management Plan (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q10"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q10"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q10?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q10', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q10.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q10.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q10.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q10.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Water Management Plan_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q11 == 'Y'"
                >
                  <label
                    for="file_c_q11"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q11
                          ?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q11?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q11,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q11?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q11?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q11,
                    }"
                  >
                    File Hydrocarbon Management Plan (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q11"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q11"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q11?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q11', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q11.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q11.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q11.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q11.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Hydrocarbon Management Plan_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q12 == 'Y'"
                >
                  <label
                    for="file_c_q12"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q12
                          ?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q12?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q12,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q12?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q12?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q12,
                    }"
                  >
                    File Emergency Response Plan (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q12"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q12"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q12?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q12', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q12.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q12.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q12.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q12.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Emergency Response Plan_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-6 mb-3"
                  v-if="formValues.persyaratanKhusus.c_q13 == 'Y'"
                >
                  <label
                    for="file_c_q13"
                    class="text-xs font-medium text-gray-600"
                    :class="{
                      'text-danger':
                        !formValues.persyaratanKhusus.assets_c_q13
                          ?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q13?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q13,
                      'text-primary':
                        formValues.persyaratanKhusus.assets_c_q13?.isVerified &&
                        status === statusIMKPEnum.NEED_REVISION &&
                        formValues.persyaratanKhusus.assets_c_q13?.file
                          ?.length >= 1 &&
                        !formValues.persyaratanKhusus.file_c_q13,
                    }"
                  >
                    File Struktur Organisasi Proyek (.pdf)
                    <span class="text-danger fs-6">*</span>
                  </label>
                  <v-file-input
                    hide-details="auto"
                    color="#475569"
                    density="compact"
                    v-model="formValues.persyaratanKhusus.file_c_q13"
                    show-size
                    prepend-icon=""
                    prepend-inner-icon="mdi-upload"
                    variant="outlined"
                    multiple
                    accept=".pdf"
                    ref="file_c_q13"
                    :clearable="false"
                    :rules="formValidasi.filePersyaratanKhusus"
                    v-if="
                      !formValues.persyaratanKhusus.assets_c_q13?.isVerified &&
                      (status === statusIMKPEnum.DRAFT ||
                        status === statusIMKPEnum.NEED_REVISION)
                    "
                  >
                    <template v-slot:selection="{ fileNames }">
                      <template
                        v-for="(fileName, index) in fileNames"
                        :key="fileName"
                      >
                        <v-chip
                          v-if="index < 2"
                          class="me-2 text-slate-800 font-normal"
                          color="#475569"
                          size="small"
                          label
                          closable
                          @click:close="removeFile('file_c_q13', index)"
                        >
                          {{ fileName }}
                        </v-chip>

                        <span
                          v-else-if="index === 2"
                          class="text-gray-500 mx-2 capitalize text-xs font-medium"
                        >
                          +{{
                            formValues.persyaratanKhusus.file_c_q13.length - 2
                          }}
                          File(s)
                        </span>
                      </template>
                    </template>
                  </v-file-input>
                  <div
                    v-if="
                      Array.isArray(
                        formValues.persyaratanKhusus.assets_c_q13.file
                      ) &&
                      formValues.persyaratanKhusus.assets_c_q13.file.length > 0
                    "
                    class="font-normal text-xs mt-1 text-gray-600"
                  >
                    <span> File saat ini : </span>
                    <ul>
                      <li
                        v-for="(file, index) in formValues.persyaratanKhusus
                          .assets_c_q13.file"
                        :key="index"
                      >
                        <div
                          class="d-flex flex-wrap align-items-center gap-3 font-medium text-slate-700"
                        >
                          <span>
                            File Struktur Organisasi Proyek_{{ index + 1 }}.pdf
                            <font-awesome-icon
                              class="text-danger cursor-pointer mx-2"
                              icon="fa-solid fa-eye"
                              @click="showFile(file)"
                            />
                            <font-awesome-icon
                              class="text-danger cursor-pointer"
                              icon="fa-solid fa-download"
                              @click="downloadFile(file)"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="col-md-12"
                  v-if="
                    formValues.persyaratanKhusus.c_q1 === 'Y' ||
                    formValues.persyaratanKhusus.c_q2 === 'Y' ||
                    formValues.persyaratanKhusus.c_q3 === 'Y' ||
                    formValues.persyaratanKhusus.c_q4 === 'Y' ||
                    formValues.persyaratanKhusus.c_q5 === 'Y' ||
                    formValues.persyaratanKhusus.c_q7 === 'Y' ||
                    formValues.persyaratanKhusus.c_q8 === 'Y' ||
                    formValues.persyaratanKhusus.c_q9 === 'Y' ||
                    formValues.persyaratanKhusus.c_q10 === 'Y' ||
                    formValues.persyaratanKhusus.c_q11 === 'Y' ||
                    formValues.persyaratanKhusus.c_q12 === 'Y' ||
                    formValues.persyaratanKhusus.c_q13 === 'Y'
                  "
                >
                  <p class="text-danger italic text-sm font-semibold">
                    * Maksimal ukuran file upload {{ max_file_size }} MB
                  </p>
                </div>
              </div>

              <p
                style="
                  font-family: 'Inter-Thin';
                  font-size: 0.9rem;
                  letter-spacing: 0.1rem;
                  font-weight: bold;
                "
              >
                D. PENGESAHAN UNTUK IZIN MELAKSANAKAN KEGIATAN PROYEK
              </p>
              <div
                class="table-responsive rounded overflow-hidden shadow-sm mb-4"
              >
                <table class="table table-bordered">
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="font-semibold text-sm m-0 ps-2">
                          Penanggung Jawab Operasional (PJO)
                        </p>
                      </td>
                    </tr>
                  </thead>
                  <thead class="table-danger">
                    <tr>
                      <td>
                        <p class="font-semibold text-sm m-0 ps-2">Nama</p>
                      </td>
                      <td>
                        <p class="font-semibold text-sm m-0 ps-2">Jabatan</p>
                      </td>
                      <td>
                        <p class="font-semibold text-sm m-0 ps-2">Tanggal</p>
                      </td>
                      <td>
                        <p class="font-semibold text-sm m-0 ps-2">
                          Tanda Tangan
                          <span class="text-danger fs-6">*</span>
                        </p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center align-bottom w-1/4">
                        <p class="text-slate-800 text-sm font-normal m-0 ps-2">
                          {{ formValues.pengesahanIzin.pjo.name }}
                        </p>
                      </td>
                      <td class="text-center align-bottom w-1/4">
                        <p class="text-slate-800 text-sm font-normal m-0 ps-2">
                          {{ formValues.pengesahanIzin.pjo.jabatan }}
                        </p>
                      </td>
                      <td class="text-center align-bottom w-1/4">
                        <p class="text-slate-800 text-sm font-normal m-0 ps-2">
                          {{
                            moment(
                              new Date(formValues.pengesahanIzin.pjo.tanggal)
                            ).format("DD MMMM YYYY")
                          }}
                        </p>
                      </td>
                      <td class="w-1/4">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <img
                            :src="url_ttdPjoFile"
                            alt="ttd-pjo"
                            style="height: 5rem"
                            class="text-center"
                            :class="{
                              'd-none': !url_ttdPjoFile,
                            }"
                            id="imagePreview"
                          />
                        </div>
                        <div
                          v-if="
                            !formValues.pengesahanIzin.pjo.ttd &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <div
                            class="input-group mb-1"
                            :class="{
                              'mt-2': !formValues.pengesahanIzin.pjo.ttd,
                            }"
                          >
                            <v-file-input
                              hide-details="auto"
                              ref="tandaTanganPjoEdit"
                              color="#475569"
                              density="compact"
                              v-model="ttdPjoFile"
                              show-size
                              prepend-icon=""
                              prepend-inner-icon="mdi-file-image"
                              variant="outlined"
                              accept="image/png, image/jpg, image/jpeg"
                              :rules="
                                status === statusIMKPEnum.DRAFT
                                  ? formValidasi.ttd
                                  : status === statusIMKPEnum.BAST_REVISION &&
                                    ttdPjoFile
                                  ? formValidasi.ttd
                                  : []
                              "
                              @update:model-value="changeTtd"
                            >
                            </v-file-input>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p
                style="
                  font-family: 'Inter-Thin';
                  font-size: 0.9rem;
                  letter-spacing: 0.1rem;
                  font-weight: bold;
                "
              >
                E. PENGAWASAN & PENANGGUNG JAWAB KEGIATAN PROYEK
              </p>
              <div
                class="table-responsive rounded overflow-hidden shadow-sm"
                :class="{
                  'mb-2': role !== levelEnum.KONTRAKTOR,
                  'mb-4': role === levelEnum.KONTRAKTOR,
                }"
              >
                <table class="table table-striped">
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="font-semibold text-sm m-0 ps-2">
                          Informasi Proyek
                        </p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <p class="text-gray-600 text-sm font-normal ps-2 m-0">
                          Judul Proyek
                        </p>
                      </td>
                      <td colspan="3">
                        <p class="text-slate-800 text-sm font-normal m-0">
                          {{ formValues.detailIzin.judulProyek || "-" }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="text-gray-600 text-sm font-normal ps-2 m-0">
                          Nomor Izin
                        </p>
                      </td>
                      <td colspan="3">
                        <p class="text-slate-800 text-sm font-normal m-0">
                          {{ formValues.detailIzin.nomorizin || "-" }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="text-gray-600 text-sm font-normal ps-2 m-0">
                          Tanggal Mulai
                        </p>
                      </td>
                      <td colspan="3">
                        <p class="text-slate-800 text-sm font-normal m-0">
                          {{
                            formValues.detailIzin.mulaiPekerjaan
                              ? moment(
                                  new Date(formValues.detailIzin.mulaiPekerjaan)
                                ).format("DD MMMM YYYY")
                              : "-"
                          }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="text-gray-600 text-sm font-normal ps-2 m-0">
                          Tanggal Selesai
                        </p>
                      </td>
                      <td colspan="3">
                        <p class="text-slate-800 text-sm font-normal m-0">
                          {{
                            formValues.detailIzin.selesaiPekerjaan
                              ? moment(
                                  new Date(
                                    formValues.detailIzin.selesaiPekerjaan
                                  )
                                ).format("DD MMMM YYYY")
                              : "-"
                          }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="text-gray-600 text-sm font-normal ps-2 m-0">
                          Durasi Lama Pekerjaan
                        </p>
                      </td>
                      <td colspan="3">
                        <p class="text-slate-800 text-sm font-normal m-0">
                          {{
                            formValues.detailIzin.durasi
                              ? formValues.detailIzin.durasi + " Hari"
                              : "-"
                          }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="text-gray-600 text-sm font-normal ps-2 m-0">
                          Kontraktor / Subkontraktor
                        </p>
                      </td>
                      <td colspan="3">
                        <p class="text-slate-800 text-sm font-normal m-0">
                          {{ formValues.detailIzin.kontraktorName || "-" }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle">
                        <p class="text-gray-600 text-sm font-normal ps-2 m-0">
                          Nama Direktur Utama
                          <span class="text-danger fs-6">*</span>
                        </p>
                      </td>
                      <td colspan="3">
                        <v-text-field
                          v-model="
                            formValues.pengawasanDanPenanggungJawab
                              .informasiProyek.namaDirekturUtama
                          "
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          bg-color="white"
                          placeholder="Direktur ..."
                          color="#475569"
                          v-if="
                            status === statusIMKPEnum.DRAFT ||
                            status === statusIMKPEnum.NEED_REVISION
                          "
                          :rules="formValidasi.namaDirekturUtama"
                        >
                        </v-text-field>
                        <p
                          class="text-slate-800 text-sm font-normal m-0"
                          v-else
                        >
                          {{
                            formValues.pengawasanDanPenanggungJawab
                              .informasiProyek.namaDirekturUtama || "-"
                          }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="text-gray-600 text-sm font-normal ps-2 m-0">
                          Jenis & Nomor Izin Usaha
                        </p>
                      </td>
                      <td colspan="3">
                        <p class="text-slate-800 text-sm font-normal m-0">
                          {{
                            formValues.pengawasanDanPenanggungJawab
                              .informasiProyek.jenis || "-"
                          }}
                          &
                          {{
                            formValues.pengawasanDanPenanggungJawab
                              .informasiProyek.nomorIzinUsaha || "-"
                          }}
                        </p>
                      </td>
                    </tr>
                  </tbody>

                  <thead class="table-danger">
                    <tr>
                      <td class="w-1/4">
                        <p class="font-semibold text-sm m-0 ps-2">
                          Kontraktor Pelaksana
                        </p>
                      </td>
                      <td class="w-1/4">
                        <p class="font-semibold text-sm m-0">Nama</p>
                      </td>
                      <td class="w-1/4">
                        <p class="font-semibold text-sm m-0">Email</p>
                      </td>
                      <td class="w-1/4">
                        <p class="font-semibold text-sm m-0">
                          Nomor Telepon (WA)
                        </p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="align-middle">
                        <p class="font-normal text-sm text-gray-600 ps-2 m-0">
                          Nama PJO
                          <span class="text-danger fs-6">*</span>
                        </p>
                      </td>
                      <td class="align-middle">
                        <p class="font-normal text-sm text-slate-800 m-0">
                          {{
                            formValues.pengawasanDanPenanggungJawab
                              .kontraktorPelaksana.pjo.name || "-"
                          }}
                        </p>
                      </td>
                      <td>
                        <v-text-field
                          v-model="
                            formValues.pengawasanDanPenanggungJawab
                              .kontraktorPelaksana.pjo.email
                          "
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          bg-color="white"
                          placeholder="example@..."
                          color="#475569"
                          :rules="formValidasi.email"
                          v-if="
                            status === statusIMKPEnum.DRAFT ||
                            status === statusIMKPEnum.NEED_REVISION
                          "
                        >
                        </v-text-field>
                        <p
                          class="font-normal text-sm text-slate-800 m-0"
                          v-else
                        >
                          {{
                            formValues.pengawasanDanPenanggungJawab
                              .kontraktorPelaksana.pjo.email || "-"
                          }}
                        </p>
                      </td>
                      <td>
                        <v-text-field
                          v-model.number="
                            formValues.pengawasanDanPenanggungJawab
                              .kontraktorPelaksana.pjo.nomor
                          "
                          variant="outlined"
                          density="compact"
                          hide-details="auto"
                          bg-color="white"
                          placeholder="62x..."
                          color="#475569"
                          :rules="formValidasi.nomor"
                          v-if="
                            status === statusIMKPEnum.DRAFT ||
                            status === statusIMKPEnum.NEED_REVISION
                          "
                        >
                        </v-text-field>
                        <p
                          class="font-normal text-sm text-slate-800 m-0"
                          v-else
                        >
                          {{
                            formValues.pengawasanDanPenanggungJawab
                              .kontraktorPelaksana.pjo.nomor || "-"
                          }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p
                          class="font-normal text-sm text-gray-600 ps-2 m-0"
                          :class="[
                            status === statusIMKPEnum.DRAFT ||
                            status === statusIMKPEnum.NEED_REVISION
                              ? 'pt-2'
                              : 'py-1',
                          ]"
                        >
                          Nama Pengawas Operasional
                          <span class="text-danger fs-6">*</span>
                        </p>
                      </td>
                      <td>
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasOperasional.name
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <v-text-field
                            v-for="(_, index) in formValues
                              .pengawasanDanPenanggungJawab.kontraktorPelaksana
                              .pengawasOperasional.name"
                            :key="index"
                            v-model="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasOperasional.name[
                                index
                              ]
                            "
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            bg-color="white"
                            placeholder="name...."
                            color="#475569"
                            :rules="formValidasi.name"
                          >
                          </v-text-field>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .pengawasOperasional.name"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasOperasional.name[
                                index
                              ]
                            }}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasOperasional.email
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <v-text-field
                            v-for="(item, index) in formValues
                              .pengawasanDanPenanggungJawab.kontraktorPelaksana
                              .pengawasOperasional.email"
                            :key="index"
                            v-model="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasOperasional.email[
                                index
                              ]
                            "
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            bg-color="white"
                            placeholder="example@..."
                            color="#475569"
                            :rules="formValidasi.email"
                          >
                          </v-text-field>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .pengawasOperasional.email"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasOperasional.email[
                                index
                              ]
                            }}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasOperasional.nomor
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues
                                .pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasOperasional.nomor"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <v-text-field
                                  v-model.number="
                                    formValues.pengawasanDanPenanggungJawab
                                      .kontraktorPelaksana.pengawasOperasional
                                      .nomor[index]
                                  "
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  bg-color="white"
                                  placeholder="62x..."
                                  color="#475569"
                                  :rules="formValidasi.nomor"
                                >
                                </v-text-field>
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('pengawasOperasional')"
                                  icon="fa-solid fa-circle-plus"
                                  style="color: #0d6efd"
                                  class="pt-3 cursor-pointer"
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="
                                    deleteRow('pengawasOperasional', index)
                                  "
                                  icon="fa-solid fa-trash"
                                  style="color: #dc3545"
                                  class="pt-3 cursor-pointer"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .pengawasOperasional.nomor"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasOperasional.nomor[
                                index
                              ]
                            }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p
                          class="font-normal text-sm text-gray-600 ps-2 m-0"
                          :class="[
                            status === statusIMKPEnum.DRAFT ||
                            status === statusIMKPEnum.NEED_REVISION
                              ? 'pt-2'
                              : 'py-1',
                          ]"
                        >
                          Nama Pengawas Teknis
                        </p>
                      </td>
                      <td>
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.name
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <v-text-field
                            v-for="(_, index) in formValues
                              .pengawasanDanPenanggungJawab.kontraktorPelaksana
                              .pengawasTeknis.name"
                            :key="index"
                            v-model="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.name[index]
                            "
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            bg-color="white"
                            placeholder="name...."
                            color="#475569"
                            :rules="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.email[
                                index
                              ] ||
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.nomor[index]
                                ? formValidasi.name
                                : []
                            "
                          >
                          </v-text-field>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .pengawasTeknis.name"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.name[index]
                            }}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.email
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <v-text-field
                            v-for="(item, index) in formValues
                              .pengawasanDanPenanggungJawab.kontraktorPelaksana
                              .pengawasTeknis.email"
                            :key="index"
                            v-model="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.email[index]
                            "
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            bg-color="white"
                            placeholder="example@..."
                            color="#475569"
                            :rules="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.name[
                                index
                              ] ||
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.nomor[index]
                                ? formValidasi.email
                                : []
                            "
                          >
                          </v-text-field>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .pengawasTeknis.email"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.email[index]
                            }}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.nomor
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues
                                .pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.nomor"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <v-text-field
                                  v-model.number="
                                    formValues.pengawasanDanPenanggungJawab
                                      .kontraktorPelaksana.pengawasTeknis.nomor[
                                      index
                                    ]
                                  "
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  bg-color="white"
                                  placeholder="62x..."
                                  color="#475569"
                                  :rules="
                                    formValues.pengawasanDanPenanggungJawab
                                      .kontraktorPelaksana.pengawasTeknis.name[
                                      index
                                    ] ||
                                    formValues.pengawasanDanPenanggungJawab
                                      .kontraktorPelaksana.pengawasTeknis.email[
                                      index
                                    ]
                                      ? formValidasi.nomor
                                      : []
                                  "
                                >
                                </v-text-field>
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('pengawasTeknis')"
                                  icon="fa-solid fa-circle-plus"
                                  style="color: #0d6efd"
                                  class="pt-3 cursor-pointer"
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="deleteRow('pengawasTeknis', index)"
                                  icon="fa-solid fa-trash"
                                  style="color: #dc3545"
                                  class="pt-3 cursor-pointer"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .pengawasTeknis.nomor"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.pengawasTeknis.nomor[index]
                            }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p
                          class="font-normal text-sm text-gray-600 ps-2 m-0"
                          :class="[
                            status === statusIMKPEnum.DRAFT ||
                            status === statusIMKPEnum.NEED_REVISION
                              ? 'pt-2'
                              : 'py-1',
                          ]"
                        >
                          Nama Tenaga Teknis Kompeten
                        </p>
                      </td>
                      <td>
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.name
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <v-text-field
                            v-for="(_, index) in formValues
                              .pengawasanDanPenanggungJawab.kontraktorPelaksana
                              .tenagaTeknisKomponen.name"
                            :key="index"
                            v-model="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.name[
                                index
                              ]
                            "
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            bg-color="white"
                            placeholder="name...."
                            color="#475569"
                            :rules="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.email[
                                index
                              ] ||
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.nomor[
                                index
                              ]
                                ? formValidasi.name
                                : []
                            "
                          >
                          </v-text-field>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .tenagaTeknisKomponen.name"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.name[
                                index
                              ]
                            }}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.email
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <v-text-field
                            v-for="(item, index) in formValues
                              .pengawasanDanPenanggungJawab.kontraktorPelaksana
                              .tenagaTeknisKomponen.email"
                            :key="index"
                            v-model="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.email[
                                index
                              ]
                            "
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            bg-color="white"
                            placeholder="example@..."
                            color="#475569"
                            :rules="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.name[
                                index
                              ] ||
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.nomor[
                                index
                              ]
                                ? formValidasi.email
                                : []
                            "
                          >
                          </v-text-field>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .tenagaTeknisKomponen.email"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.email[
                                index
                              ]
                            }}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.nomor
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues
                                .pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.nomor"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <v-text-field
                                  v-model.number="
                                    formValues.pengawasanDanPenanggungJawab
                                      .kontraktorPelaksana.tenagaTeknisKomponen
                                      .nomor[index]
                                  "
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  bg-color="white"
                                  placeholder="62x..."
                                  color="#475569"
                                  :rules="
                                    formValues.pengawasanDanPenanggungJawab
                                      .kontraktorPelaksana.tenagaTeknisKomponen
                                      .name[index] ||
                                    formValues.pengawasanDanPenanggungJawab
                                      .kontraktorPelaksana.tenagaTeknisKomponen
                                      .email[index]
                                      ? formValidasi.nomor
                                      : []
                                  "
                                >
                                </v-text-field>
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('tenagaTeknisKompeten')"
                                  icon="fa-solid fa-circle-plus"
                                  style="color: #0d6efd"
                                  class="pt-3 cursor-pointer"
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="
                                    deleteRow('tenagaTeknisKompeten', index)
                                  "
                                  icon="fa-solid fa-trash"
                                  style="color: #dc3545"
                                  class="pt-3 cursor-pointer"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .tenagaTeknisKomponen.nomor"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.tenagaTeknisKomponen.nomor[
                                index
                              ]
                            }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p
                          class="font-normal text-sm text-gray-600 ps-2 m-0"
                          :class="[
                            status === statusIMKPEnum.DRAFT ||
                            status === statusIMKPEnum.NEED_REVISION
                              ? 'pt-2'
                              : 'py-1',
                          ]"
                        >
                          Nama HSE Officer
                          <span class="text-danger fs-6">*</span>
                        </p>
                      </td>
                      <td>
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.hseOfficer.name
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <v-text-field
                            v-for="(_, index) in formValues
                              .pengawasanDanPenanggungJawab.kontraktorPelaksana
                              .hseOfficer.name"
                            :key="index"
                            v-model="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.hseOfficer.name[index]
                            "
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            bg-color="white"
                            placeholder="name...."
                            color="#475569"
                            :rules="formValidasi.name"
                          >
                          </v-text-field>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .hseOfficer.name"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.hseOfficer.name[index]
                            }}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.hseOfficer.email
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <v-text-field
                            v-for="(item, index) in formValues
                              .pengawasanDanPenanggungJawab.kontraktorPelaksana
                              .hseOfficer.email"
                            :key="index"
                            v-model="
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.hseOfficer.email[index]
                            "
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            bg-color="white"
                            placeholder="example@..."
                            color="#475569"
                            :rules="formValidasi.email"
                          >
                          </v-text-field>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .hseOfficer.email"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.hseOfficer.email[index]
                            }}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.hseOfficer.nomor
                            ) &&
                            (status === statusIMKPEnum.DRAFT ||
                              status === statusIMKPEnum.NEED_REVISION)
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues
                                .pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.hseOfficer.nomor"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <v-text-field
                                  v-model.number="
                                    formValues.pengawasanDanPenanggungJawab
                                      .kontraktorPelaksana.hseOfficer.nomor[
                                      index
                                    ]
                                  "
                                  variant="outlined"
                                  density="compact"
                                  hide-details="auto"
                                  bg-color="white"
                                  placeholder="62x..."
                                  color="#475569"
                                  :rules="formValidasi.nomor"
                                >
                                </v-text-field>
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('hseOfficer')"
                                  icon="fa-solid fa-circle-plus"
                                  style="color: #0d6efd"
                                  class="pt-3 cursor-pointer"
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="deleteRow('hseOfficer', index)"
                                  icon="fa-solid fa-trash"
                                  style="color: #0d6efd"
                                  class="pt-3 cursor-pointer"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(_, index) in formValues
                            .pengawasanDanPenanggungJawab.kontraktorPelaksana
                            .hseOfficer.nomor"
                          :key="index"
                        >
                          <p
                            class="font-normal text-sm text-slate-800 m-0 mb-1 mt-1"
                          >
                            {{
                              formValues.pengawasanDanPenanggungJawab
                                .kontraktorPelaksana.hseOfficer.nomor[index]
                            }}
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <template
                v-if="
                  (status === statusIMKPEnum.DRAFT ||
                    status === statusIMKPEnum.NEED_REVISION) &&
                  !isObsolete
                "
              >
                <div
                  class="d-flex justify-content-end"
                  v-if="role === levelEnum.KONTRAKTOR && !hasImkpBast"
                >
                  <v-btn
                    class="bg-red-600 text-white capitalize w-1/4"
                    :loading="isLoading"
                    :disabled="isLoading"
                    @click.prevent="clickSimpan"
                  >
                    Simpan
                  </v-btn>
                </div>
                <div class="d-flex justify-content-end" v-else>
                  <v-btn class="bg-red-600 text-white capitalize">
                    <font-awesome-icon
                      icon="fa-solid fa-circle-minus"
                      style="color: #eeecec"
                    />
                    Anda tidak dapat melakukan pengajuan IMKP. <br />
                    Silahkan lakukan BAST telebih dahulu pada IMKP yang telah
                    lewat tanggal selesai pekerjaannya.
                  </v-btn>
                </div>
              </template>
            </v-form>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <ModalComponent :id="'error-message'" :modalType="2" :modalSize="'modal-lg'">
    <div style="max-height: 80vh; overflow-y: auto">
      <div v-html="errorMessage"></div>
    </div>
  </ModalComponent>
  <ModalComponent :id="'persyaratan-khusus-message'" :modalType="2">
    <div style="max-height: 80vh; overflow-y: auto">
      <table class="table table-striped">
        <tbody>
          <tr>
            <td>
              <p class="fs-9 ms-2 m-0">Daftar Periksa</p>
            </td>
            <td colspan="3">
              <p class="fs-9 m-0">
                {{ persyaratanKhususTitle }}
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p class="fs-9 ms-2 m-0">Catatan</p>
            </td>
            <td colspan="3">
              <p class="fs-9 m-0" style="white-space: pre-line">
                {{ persyaratanKhususNote }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ModalComponent>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  CMS_DOWNLOAD_ESIGN,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_IMKP_DETAIL,
  CMS_SET_IMKP,
  // CMS_SIO_SET_KELENGKAPAN,
  CMS_VIEW_IMAGE,
} from "../../constants.js";
import { levelEnum } from "@/utilities/enum";
import {
  downloadFile,
  getSIOByIDContractor,
  showFile,
} from "@/utilities/globalFunction";
import { getESBLocation, getESBSubLocation } from "@/utilities/ESBE";
import { validateObject } from "@/utilities/validateInput";
import ModalComponent from "@/components/ModalComponent.vue";
import UploadFileService from "@/utilities/upload-file";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { FormValidasiImkp } from "./core/FormData";
import {
  formatSubLokasiDisplay,
  parseSubLokasiFromApi,
  serializeSubLokasiForApi,
} from "./core/subLokasiHelpers";
import util from "@/assets/js/util";

const url_imkp_detail = API_BASE_URL + CMS_IMKP_DETAIL;
const max_file_size = 5;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;
const url_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_imkp = API_BASE_URL + CMS_SET_IMKP;
// const url_set_kelengkapan = API_BASE_URL + CMS_SIO_SET_KELENGKAPAN;
const url_download_esign = API_BASE_URL + CMS_DOWNLOAD_ESIGN;

export default {
  mixins: [GlobalDataMixin],
  name: "DetailImkpPage",
  components: { DefaultLayout, ModalComponent },
  data() {
    return {
      isLoading: false,
      role: null,
      userRole: null,
      errorMessage: "",
      formValues: {
        detailIzin: {
          kontraktorName: null,
          namaPemegangIzin: null,
          lokasiKerja: "",
          subLokasiKerja: [],
          keteranganLokasiKerja: null,
          judulProyek: null,
          nomorizin: null,
          mulaiPekerjaan: null,
          selesaiPekerjaan: null,
          durasi: null,
        },
        detailPekerjaan: {
          uraianPekerjaan: null,
        },
        persyaratanKhusus: {
          c_q1: "Y",
          c_q2: "Y",
          c_q3: "Y",
          c_q4: "Y",
          c_q5: "Y",
          c_q6: "Y",
          c_q7: "Y",
          c_q8: "Y",
          c_q9: "T",
          c_q10: "T",
          c_q11: "T",
          c_q12: "Y",
          c_q13: "Y",
          tindakPencegahan: null,
          file_c_q1: null,
          file_c_q2: null,
          file_c_q3: null,
          file_c_q4: null,
          file_c_q5: null,
          file_c_q6: null,
          file_c_q7: null,
          file_c_q8: null,
          file_c_q9: null,
          file_c_q10: null,
          file_c_q11: null,
          file_c_q12: null,
          file_c_q13: null,
          assets_c_q1: { file: [] },
          assets_c_q2: { file: [] },
          assets_c_q3: { file: [] },
          assets_c_q4: { file: [] },
          assets_c_q5: { file: [] },
          assets_c_q6: { file: [] },
          assets_c_q7: { file: [] },
          assets_c_q8: { file: [] },
          assets_c_q9: { file: [] },
          assets_c_q10: { file: [] },
          assets_c_q11: { file: [] },
          assets_c_q12: { file: [] },
          assets_c_q13: { file: [] },
        },
        pengesahanIzin: {
          pjo: {
            name: null,
            jabatan: null,
            tanggal: new Date(),
            ttd: null,
          },
        },
        pengawasanDanPenanggungJawab: {
          informasiProyek: {
            namaDirekturUtama: null,
            jenis: null,
            nomorIzinUsaha: null,
          },
          kontraktorPelaksana: {
            pjo: {
              name: null,
              email: null,
              nomor: null,
            },
            pengawasOperasional: {
              name: [],
              email: [],
              nomor: [],
            },
            pengawasTeknis: {
              name: [],
              email: [],
              nomor: [],
            },
            tenagaTeknisKomponen: {
              name: [],
              email: [],
              nomor: [],
            },
            hseOfficer: {
              name: [],
              email: [],
              nomor: [],
            },
          },
        },
      },
      formValidasi: FormValidasiImkp,
      sioID: null,
      isBlockReqImkp: false,
      hasImkpBast: false,
      kontaktorID: null,
      kelengkapanID: null,
      ttdPjoFile: null,
      url_ttdPjoFile: null,
      validasiFileEdit: {
        typeTtdPjo: false,
        sizeTtdPjo: false,
      },
      listLokasi: [],
      listSubLokasi: [],
      isLoadingLokasi: false,
      isLoadingSubLokasi: false,
      status: null,
      documentIdImkp: null,
      downloadUrlImkp: null,
      subLocation: null,
      reason: "",
      persyaratanKhususTitle: "",
      persyaratanKhususNote: "",
      messageUraianPekerjaan: {},
      messageTindakPencegahan: {},
      maxLines: 9,
      maxCharsPerLine: 112,
      isObsolete: false,
    };
  },
  created() {
    this.userRole = Array.isArray(this.userData.role)
      ? "isafe"
      : this.userData.role;

    this.uploadFileService = new UploadFileService(
      this.userData.token,
      this.userRole
    );
  },
  mounted() {
    this.role = this.userData.role.includes("ADMIN")
      ? levelEnum.ADMIN
      : this.userData.role.includes("OHS")
      ? levelEnum.OHS
      : this.userData.role.includes("reporter")
      ? levelEnum.REPORTER
      : this.userData.role === levelEnum.KONTRAKTOR
      ? levelEnum.KONTRAKTOR
      : levelEnum.ISAFE;

    if (
      this.role !== levelEnum.KONTRAKTOR &&
      this.role !== levelEnum.REPORTER &&
      this.role !== levelEnum.ISAFE
    ) {
      this.$router.push("/dashboard");
    }

    this.getIMKP(this.$route.params.id);

    this.formValues.detailIzin.nomorizin = `IMKP-${new Date().getFullYear()}-Generate by System`;
  },
  watch: {
    "formValues.detailIzin.mulaiPekerjaan": {
      handler() {
        if (
          this.formValues.detailIzin.mulaiPekerjaan &&
          this.formValues.detailIzin.selesaiPekerjaan
        ) {
          const mulai = new Date(this.formValues.detailIzin.mulaiPekerjaan);
          const selesai = new Date(this.formValues.detailIzin.selesaiPekerjaan);

          if (mulai && selesai && !isNaN(mulai) && !isNaN(selesai)) {
            const diffTime = selesai.getTime() - mulai.getTime();

            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            this.formValues.detailIzin.durasi = Math.round(diffDays);
          } else {
            this.formValues.detailIzin.durasi = "-";
          }
        }
      },
    },
    "formValues.detailIzin.selesaiPekerjaan": {
      handler() {
        if (
          this.formValues.detailIzin.mulaiPekerjaan &&
          this.formValues.detailIzin.selesaiPekerjaan
        ) {
          const mulai = new Date(this.formValues.detailIzin.mulaiPekerjaan);
          const selesai = new Date(this.formValues.detailIzin.selesaiPekerjaan);

          if (mulai && selesai && !isNaN(mulai) && !isNaN(selesai)) {
            const diffTime = selesai.getTime() - mulai.getTime();

            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            this.formValues.detailIzin.durasi = Math.round(diffDays);
          } else {
            this.formValues.detailIzin.durasi = "-";
          }
        }
      },
    },
    "formValues.detailIzin.lokasiKerja": {
      handler(newVal) {
        if (
          newVal?.id &&
          (this.status === statusIMKPEnum.DRAFT ||
            this.status === statusIMKPEnum.NEED_REVISION)
        ) {
          this.getSubLocation(null, this.subLocation);
        } else if (
          this.status === statusIMKPEnum.DRAFT ||
          this.status === statusIMKPEnum.NEED_REVISION
        ) {
          this.formValues.detailIzin.subLokasiKerja = [];
        }
      },
    },
    "formValues.detailPekerjaan.uraianPekerjaan": {
      handler() {
        if (!this.isLoading) {
          this.handleValidasiTextArea();
        }
      },
      deep: true,
    },
    "formValues.persyaratanKhusus.tindakPencegahan": {
      handler() {
        if (!this.isLoading) {
          this.handleValidasiTextArea();
        }
      },
      deep: true,
    },
  },
  methods: {
    downloadFile,
    showFile,
    formatSubLokasiDisplay,
    async getIMKP(id) {
      try {
        this.isLoading = true;

        let params = {
          id: id,
        };

        const result = await axios.get(url_imkp_detail, {
          params: params,
          headers: {
            role: this.userRole,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        const res = result.data.data[0];

        if (res) {
          this.status = res.status;

          this.formValues.detailIzin.judulProyek = res.judulProyek;
          this.kontaktorID = res.idKontraktor;
          this.documentIdImkp = res.documentIdImkp;
          this.downloadUrlImkp = res.downloadUrlImkp;
          const sio = await getSIOByIDContractor(this.kontaktorID);
          this.sioID = sio.data.id;
          this.isBlockReqImkp = sio.isBlockReqImkp;
          this.isObsolete = res.isObsolete;
          this.hasImkpBast = sio.hasImkpBast;
          await this.getKelengkapan(this.sioID, sio);
          this.getKontraktor(this.kontaktorID);
          if (
            this.status === statusIMKPEnum.DRAFT ||
            this.status === statusIMKPEnum.NEED_REVISION
          ) {
            this.subLocation = res.subLokasi;
            this.getLocation(null, res.lokasiKerja);
          } else {
            this.formValues.detailIzin.lokasiKerja = res.lokasiKerja;
            this.formValues.detailIzin.subLokasiKerja = parseSubLokasiFromApi(
              res.subLokasi,
            );
          }

          this.formValues.detailIzin.keteranganLokasiKerja =
            res.keteranganLokasiKerja;
          this.formValues.detailIzin.mulaiPekerjaan = res.tanggalMulaiPekerjaan
            ? new Date(res.tanggalMulaiPekerjaan)
            : null;
          this.formValues.detailIzin.selesaiPekerjaan =
            res.tanggalSelesaiPekerjaan
              ? new Date(res.tanggalSelesaiPekerjaan)
              : null;

          this.formValues.detailPekerjaan.uraianPekerjaan =
            res.deskripsiPekerjaan;

          const formPersyaratanKhusus = res.persyaratanKhusus;

          if (validateObject(formPersyaratanKhusus)) {
            this.formValues.persyaratanKhusus.c_q1 = formPersyaratanKhusus.c_q1;
            this.formValues.persyaratanKhusus.c_q2 = formPersyaratanKhusus.c_q2;
            this.formValues.persyaratanKhusus.c_q3 = formPersyaratanKhusus.c_q3;
            this.formValues.persyaratanKhusus.c_q4 = formPersyaratanKhusus.c_q4;
            this.formValues.persyaratanKhusus.c_q5 = formPersyaratanKhusus.c_q5;
            this.formValues.persyaratanKhusus.c_q6 = formPersyaratanKhusus.c_q6;
            this.formValues.persyaratanKhusus.c_q7 = formPersyaratanKhusus.c_q7;
            this.formValues.persyaratanKhusus.c_q8 = formPersyaratanKhusus.c_q8;
            this.formValues.persyaratanKhusus.c_q9 = formPersyaratanKhusus.c_q9;
            this.formValues.persyaratanKhusus.c_q10 =
              formPersyaratanKhusus.c_q10;
            this.formValues.persyaratanKhusus.c_q11 =
              formPersyaratanKhusus.c_q11;
            this.formValues.persyaratanKhusus.c_q12 =
              formPersyaratanKhusus.c_q12;
            this.formValues.persyaratanKhusus.c_q13 =
              formPersyaratanKhusus.c_q13;
          }

          const assets = res.assets;
          if (validateObject(assets)) {
            this.formValues.persyaratanKhusus.assets_c_q1 = assets.assets_c_q1;
            this.formValues.persyaratanKhusus.assets_c_q2 = assets.assets_c_q2;
            this.formValues.persyaratanKhusus.assets_c_q3 = assets.assets_c_q3;
            this.formValues.persyaratanKhusus.assets_c_q4 = assets.assets_c_q4;
            this.formValues.persyaratanKhusus.assets_c_q5 = assets.assets_c_q5;
            this.formValues.persyaratanKhusus.assets_c_q6 = assets.assets_c_q6;
            this.formValues.persyaratanKhusus.assets_c_q7 = assets.assets_c_q7;
            this.formValues.persyaratanKhusus.assets_c_q8 = assets.assets_c_q8;
            this.formValues.persyaratanKhusus.assets_c_q9 = assets.assets_c_q9;
            this.formValues.persyaratanKhusus.assets_c_q10 =
              assets.assets_c_q10;
            this.formValues.persyaratanKhusus.assets_c_q11 =
              assets.assets_c_q11;
            this.formValues.persyaratanKhusus.assets_c_q12 =
              assets.assets_c_q12;
            this.formValues.persyaratanKhusus.assets_c_q13 =
              assets.assets_c_q13;
          }

          this.formValues.persyaratanKhusus.tindakPencegahan =
            res.tindakPencegahan;

          if (res.tglTtdPjo) {
            this.formValues.pengesahanIzin.pjo.tanggal = res.tglTtdPjo;
          }

          this.formValues.pengawasanDanPenanggungJawab.informasiProyek.namaDirekturUtama =
            res.namaDirekturUtama;

          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pjo.email =
            res.emailPjo;
          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pjo.nomor =
            res.noTeleponPjo;

          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasOperasional.name =
            res.namaPengawasOperasional
              ? JSON.parse(res.namaPengawasOperasional)
              : [null];
          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasOperasional.email =
            res.emailPengawasOperasional
              ? JSON.parse(res.emailPengawasOperasional)
              : [null];
          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasOperasional.nomor =
            res.noTeleponPengawasOperasional
              ? JSON.parse(res.noTeleponPengawasOperasional)
              : [null];

          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.name =
            res.namaPengawasTeknis
              ? JSON.parse(res.namaPengawasTeknis)
              : [null];
          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.email =
            res.emailPengawasTeknis
              ? JSON.parse(res.emailPengawasTeknis)
              : [null];
          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.nomor =
            res.noTeleponPengawasTeknis
              ? JSON.parse(res.noTeleponPengawasTeknis)
              : [null];

          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.name =
            res.namaTenagaTeknisKompeten
              ? JSON.parse(res.namaTenagaTeknisKompeten)
              : [null];
          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.email =
            res.emailTenagaTeknisKompeten
              ? JSON.parse(res.emailTenagaTeknisKompeten)
              : [null];
          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.nomor =
            res.noTeleponTenagaTeknisKompeten
              ? JSON.parse(res.noTeleponTenagaTeknisKompeten)
              : [null];

          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.hseOfficer.name =
            res.namaHseOfficer ? JSON.parse(res.namaHseOfficer) : [null];
          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.hseOfficer.email =
            res.emailHseOfficer ? JSON.parse(res.emailHseOfficer) : [null];
          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.hseOfficer.nomor =
            res.noTeleponHseOfficer
              ? JSON.parse(res.noTeleponHseOfficer)
              : [null];

          this.reason = res.alasanTolak;
        }
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data detail IMKP!",
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getKelengkapan(id, sio) {
      try {
        const res = await axios.get(url_get_kelengkapan + id, {
          headers: {
            role: this.userRole,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        if (sio.data.downloadUrlPjo != null) {
          this.formValues.pengesahanIzin.pjo.name = res.data.namaPjo;
          this.formValues.pengesahanIzin.pjo.jabatan = res.data.jabatanPjo;
          this.formValues.pengesahanIzin.pjo.ttd = res.data.ttdPjo;

          this.formValues.detailIzin.namaPemegangIzin = res.data.namaPjo;

          this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pjo.name =
            res.data.namaPjo;
        }

        if (res.data.ttdPjo !== "" && res.data.ttdPjo) {
          this.url_ttdPjoFile = API_BASE_URL + CMS_VIEW_IMAGE + res.data.ttdPjo;
        }

        this.kelengkapanID = res.data.id;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data kelengkapan!",
        });
      }
    },
    async getKontraktor(id) {
      try {
        const res = await axios.get(url_kontraktor + id, {
          headers: {
            role: this.userRole,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        if (res) {
          const kontaktor = res.data.detailKontraktor;

          this.formValues.detailIzin.kontraktorName = kontaktor.namaKontraktor;
          if (!this.formValues.detailIzin.namaPemegangIzin) {
            this.formValues.detailIzin.namaPemegangIzin = kontaktor.namaPjo;
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pjo.name =
              kontaktor.namaPjo;

            this.formValues.pengesahanIzin.pjo.name = kontaktor.namaPjo;
            this.formValues.pengesahanIzin.pjo.jabatan =
              "Penanggung Jawab Operasional";
          }

          this.formValues.pengawasanDanPenanggungJawab.informasiProyek.jenis =
            kontaktor.jenis;
          this.formValues.pengawasanDanPenanggungJawab.informasiProyek.nomorIzinUsaha =
            kontaktor.jenis.toLocaleLowerCase() === "non inti"
              ? kontaktor.nib
              : kontaktor.iujp;
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data kontraktor!",
        });
      }
    },
    async getLocation(event = null, existingLocation = null) {
      try {
        this.isLoadingLokasi = true;
        let inputValue = event?.target?.value || existingLocation;

        const res = await getESBLocation(inputValue);
        this.listLokasi = res.dataLocation;
        if (inputValue) {
          this.formValues.detailIzin.lokasiKerja = res.dataLocation.find(
            (location) => location.location_name == inputValue
          );
        }
      } catch (error) {
        this.listLokasi = [];
        this.isLoadingLokasi = false;
      } finally {
        this.isLoadingLokasi = false;
      }
    },
    async getSubLocation(event = null, existingSubLocation = null) {
      try {
        this.isLoadingSubLokasi = true;
        const inputValue = event?.target?.value;
        const id_location = this.formValues.detailIzin.lokasiKerja.id;

        if (id_location) {
          const res = await getESBSubLocation(id_location, inputValue);
          this.listSubLokasi = res.dataSubLocation;

          if (existingSubLocation) {
            const names = parseSubLokasiFromApi(existingSubLocation);
            this.formValues.detailIzin.subLokasiKerja = names
              .map((name) =>
                res.dataSubLocation.find((sub) => sub.name === name),
              )
              .filter(Boolean);
          } else {
            this.formValues.detailIzin.subLokasiKerja = [];
          }
        }
      } catch (error) {
        this.listSubLokasi = [];
        this.isLoadingSubLokasi = false;
      } finally {
        this.subLocation = null;
        this.isLoadingSubLokasi = false;
      }
    },
    getUploadedFilename(file) {
      if (!file) return null;
      if (file._uploadedFilename) return file._uploadedFilename;
      if (this.uploadedFilesMap && this.uploadedFilesMap.has(file)) {
        return this.uploadedFilesMap.get(file);
      }
      return null;
    },
    setUploadedFilename(file, filename) {
      if (!file) return;
      try {
        file._uploadedFilename = filename;
      } catch (e) {
        // Fallback for non-extensible objects
      }
      if (!this.uploadedFilesMap) {
        this.uploadedFilesMap = new WeakMap();
      }
      this.uploadedFilesMap.set(file, filename);
    },
    async clickSimpan() {
      const validate = await this.$refs.formData.validate();
      if (!validate.valid) {
        util.showError("Terdapat kolom yang tidak sesuai.");
        return;
      }

      const confirmResult = await Swal.fire({
        title: "Konfirmasi Simpan",
        text: "Apakah Anda yakin ingin menyimpan data pengajuan IMKP ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc2626",
        cancelButtonColor: "#6b7280",
        confirmButtonText: "Ya, Simpan",
        cancelButtonText: "Batal",
        reverseButtons: true,
      });

      if (!confirmResult.isConfirmed) {
        return;
      }

      Swal.fire({
        title: "Mohon Tunggu",
        text: "Sedang mengunggah berkas dan menyimpan data...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        this.isLoading = true;

        const uploadSuccess = await this.uploadFilePersyaratanKhusus();
        if (!uploadSuccess) {
          return;
        }

        if (this.checkFileJson()) {
          await this.doSave();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Maaf, terdapat kesalahan saat upload file, mohon kirim ulang.",
          });
        }
      } catch (error) {
        console.error("Error saat menyimpan data IMKP:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error?.response?.data?.status?.message ||
            error?.response?.data?.message ||
            error?.message ||
            "Terjadi kesalahan saat menyimpan data!",
        });
      } finally {
        this.isLoading = false;
      }
    },
    async doSave() {
      try {
        if (!this.formValues.pengesahanIzin.pjo.ttd && this.ttdPjoFile) {
          await this.updateTtdPjo();
        }

        const formPersyaratanKhusus = {};
        const assetsPersyaratanKhusus = {};

        for (let i = 1; i <= 13; i++) {
          const key = `c_q${i}`;
          const assetsKey = `assets_c_q${i}`;

          formPersyaratanKhusus[key] = this.formValues.persyaratanKhusus[key];

          assetsPersyaratanKhusus[assetsKey] = {
            file: this.formValues.persyaratanKhusus[assetsKey].file,
            isVerified: false,
            note: this.formValues.persyaratanKhusus[assetsKey].note,
          };
        }

        const now = new Date();

        const mulaiPekerjaan = new Date(
          this.formValues.detailIzin.mulaiPekerjaan
        );
        mulaiPekerjaan.setHours(
          now.getHours(),
          now.getMinutes(),
          now.getSeconds()
        );

        const selesaiPekerjaan = new Date(
          this.formValues.detailIzin.selesaiPekerjaan
        );
        selesaiPekerjaan.setHours(
          now.getHours(),
          now.getMinutes(),
          now.getSeconds()
        );

        let bodyJson = {
          usecase: "kontraktor",
          id: parseInt(this.$route.params.id),
          imkpId: parseInt(this.$route.params.id),
          idSio: this.sioID,
          kontraktorId: this.kontaktorID,
          namaPemegangIzin: this.formValues.detailIzin.namaPemegangIzin,
          lokasiKerja: this.formValues.detailIzin.lokasiKerja.location_name,
          subLokasi: serializeSubLokasiForApi(
            this.formValues.detailIzin.subLokasiKerja,
          ),
          keteranganLokasiKerja:
            this.formValues.detailIzin.keteranganLokasiKerja,
          judulProyek: this.formValues.detailIzin.judulProyek,
          tanggalMulaiPekerjaan: mulaiPekerjaan,
          tanggalSelesaiPekerjaan: selesaiPekerjaan,

          deskripsiPekerjaan: this.formValues.detailPekerjaan.uraianPekerjaan,

          persyaratanKhusus: JSON.stringify(formPersyaratanKhusus),
          assets: JSON.stringify(assetsPersyaratanKhusus),
          tindakPencegahan: this.formValues.persyaratanKhusus.tindakPencegahan,

          namaDirekturUtama:
            this.formValues.pengawasanDanPenanggungJawab.informasiProyek
              .namaDirekturUtama,

          tglTtdPjo: this.formValues.pengesahanIzin.pjo.tanggal,

          namaPjo:
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pjo
              .name,
          emailPjo:
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pjo
              .email,
          noTeleponPjo:
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pjo
              .nomor,

          namaPengawasOperasional: JSON.stringify(
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana
              .pengawasOperasional.name
          ),
          emailPengawasOperasional: JSON.stringify(
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana
              .pengawasOperasional.email
          ),
          noTeleponPengawasOperasional: JSON.stringify(
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana
              .pengawasOperasional.nomor
          ),

          namaPengawasTeknis:
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.name.filter(
              (item) => item
            ).length > 0
              ? JSON.stringify(
                  this.formValues.pengawasanDanPenanggungJawab
                    .kontraktorPelaksana.pengawasTeknis.name
                )
              : null,
          emailPengawasTeknis:
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.email.filter(
              (item) => item
            ).length > 0
              ? JSON.stringify(
                  this.formValues.pengawasanDanPenanggungJawab
                    .kontraktorPelaksana.pengawasTeknis.email
                )
              : null,
          noTeleponPengawasTeknis:
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.nomor.filter(
              (item) => item
            ).length > 0
              ? JSON.stringify(
                  this.formValues.pengawasanDanPenanggungJawab
                    .kontraktorPelaksana.pengawasTeknis.nomor
                )
              : null,

          namaTenagaTeknisKompeten:
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.name.filter(
              (item) => item
            ).length > 0
              ? JSON.stringify(
                  this.formValues.pengawasanDanPenanggungJawab
                    .kontraktorPelaksana.tenagaTeknisKomponen.name
                )
              : null,
          emailTenagaTeknisKompeten:
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.email.filter(
              (item) => item
            ).length > 0
              ? JSON.stringify(
                  this.formValues.pengawasanDanPenanggungJawab
                    .kontraktorPelaksana.tenagaTeknisKomponen.email
                )
              : null,
          noTeleponTenagaTeknisKompeten:
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.nomor.filter(
              (item) => item
            ).length > 0
              ? JSON.stringify(
                  this.formValues.pengawasanDanPenanggungJawab
                    .kontraktorPelaksana.tenagaTeknisKomponen.nomor
                )
              : null,

          namaHseOfficer: JSON.stringify(
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana
              .hseOfficer.name
          ),
          emailHseOfficer: JSON.stringify(
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana
              .hseOfficer.email
          ),
          noTeleponHseOfficer: JSON.stringify(
            this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana
              .hseOfficer.nomor
          ),

          userId: this.userData.userId,
        };

        const response = await axios.post(url_imkp, bodyJson, {
          headers: {
            role: this.userRole,
            Authorization: "Bearer " + this.userData.token,
            Accept: "application/json",
          },
        });

        if (response.data.status.code === 500) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response?.data?.status?.message || "Terjadi kesalahan pada server.",
          });
        } else {
          Swal.fire({
            title: "Pengajuan IMKP",
            text: "Pengajuan IMKP berhasil dilengkapi!",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            this.$router.push({
              path: "/imkp",
              query: this.$route.query,
            });
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error?.response?.data?.status?.message ||
            error?.response?.data?.message ||
            error?.status?.message ||
            "Terjadi kesalahan saat menyimpan data!",
        });
      }
    },
    async updateTtdPjo() {
      const file = this.ttdPjoFile;
      if (file) {
        await this.uploadFileTtdPjo(file);
      }
    },
    async uploadFileTtdPjo(file) {
      try {
        await this.uploadFileService.uploadUsecase(
          file,
          this.kelengkapanID,
          "pjo",
          "kelengkapan"
        );
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat update ttd PJO!",
        });
      }
    },
    async uploadFilePersyaratanKhusus() {
      const item = this.formValues.persyaratanKhusus;

      for (let i = 1; i <= 13; i++) {
        const key = `c_q${i}`;
        const fileKey = `file_${key}`;
        const assetsKey = `assets_${key}`;

        if (
          !item[assetsKey]?.isVerified &&
          item[key] === "Y" &&
          Array.isArray(item[fileKey]) &&
          item[fileKey].length >= 1
        ) {
          const uploadedFilenames = [];
          for (const file of item[fileKey]) {
            let filename = this.getUploadedFilename(file);
            if (!filename) {
              try {
                const res = await this.uploadFileService.uploadFile(file);
                if (res && res.filename) {
                  filename = res.filename;
                  this.setUploadedFilename(file, filename);
                } else {
                  throw new Error("Respon upload file tidak valid");
                }
              } catch (error) {
                console.error(`Error uploading file for ${key}:`, error);
                Swal.fire({
                  icon: "error",
                  title: "Upload Gagal",
                  text: "Terjadi kesalahan saat mengunggah berkas. Silakan coba lagi.",
                });
                return false;
              }
            }
            uploadedFilenames.push(filename);
          }
          item[assetsKey].file = uploadedFilenames;
        }
      }
      return true;
    },
    removeFile(refFile, index) {
      const list = this.formValues.persyaratanKhusus[refFile];
      if (list && list.length > index) {
        list.splice(index, 1);

        if (this.$refs[refFile].validate) {
          this.$nextTick(() => {
            this.$refs[refFile].validate();
          });
        }
      }
    },
    changeTtd() {
      let file = this.ttdPjoFile;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.url_ttdPjoFile = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    addRow(row) {
      if (row === "pengawasOperasional") {
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasOperasional.name.push(
          null
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasOperasional.email.push(
          null
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasOperasional.nomor.push(
          null
        );
      }
      if (row === "pengawasTeknis") {
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.name.push(
          null
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.email.push(
          null
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.nomor.push(
          null
        );
      }
      if (row === "tenagaTeknisKompeten") {
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.name.push(
          null
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.email.push(
          null
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.nomor.push(
          null
        );
      }
      if (row === "hseOfficer") {
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.hseOfficer.name.push(
          null
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.hseOfficer.email.push(
          null
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.hseOfficer.nomor.push(
          null
        );
      }
    },
    deleteRow(row, indexRemove) {
      if (row === "pengawasOperasional") {
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasOperasional.name.splice(
          indexRemove,
          1
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasOperasional.email.splice(
          indexRemove,
          1
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasOperasional.nomor.splice(
          indexRemove,
          1
        );
      }
      if (row === "pengawasTeknis") {
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.name.splice(
          indexRemove,
          1
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.email.splice(
          indexRemove,
          1
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.pengawasTeknis.nomor.splice(
          indexRemove,
          1
        );
      }
      if (row === "tenagaTeknisKompeten") {
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.name.splice(
          indexRemove,
          1
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.email.splice(
          indexRemove,
          1
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.tenagaTeknisKomponen.nomor.splice(
          indexRemove,
          1
        );
      }
      if (row === "hseOfficer") {
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.hseOfficer.name.splice(
          indexRemove,
          1
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.hseOfficer.email.splice(
          indexRemove,
          1
        );
        this.formValues.pengawasanDanPenanggungJawab.kontraktorPelaksana.hseOfficer.nomor.splice(
          indexRemove,
          1
        );
      }
    },
    openModal(title, data) {
      this.persyaratanKhususTitle = title;
      this.persyaratanKhususNote = data.note;
      let button = document.createElement("a");
      button.setAttribute("id", "persyaratanKhususModal");
      button.setAttribute("data-bs-toggle", "modal");
      button.setAttribute("data-bs-target", "#persyaratan-khusus-message");
      document.body.appendChild(button);
      document.querySelector("#persyaratanKhususModal").click();
      button.remove();
    },
    checkFileJson() {
      let status = true;

      for (let i = 1; i <= 13; i++) {
        const key = `c_q${i}`;
        const assetKey = `assets_${key}`;

        const value = this.formValues.persyaratanKhusus[key];

        const file = this.formValues.persyaratanKhusus[assetKey];
        const hasFile = file && file.file && file.file.length > 0;

        if (value === "Y" && !hasFile) {
          status = false;
          break;
        }
      }

      return status;
    },
    downloadFileEsign(id) {
      this.isLoading = true;
      let filename = `File IMKP ${this.formValues.detailIzin.kontraktorName}.zip`;
      axios
        .get(url_download_esign, {
          params: { id: id },
          headers: {
            role: this.userData.role,
            Authorization: `Bearer ${this.userData.token}`,
            Accept: "application/json",
          },
          responseType: "blob", // Ensure binary data handling
        })
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Network response was not ok");
          }
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); // Use the filename from the header or default one
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url); // Clean up the URL object
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error downloading file:", error);
        });
    },
    handleValidasiTextArea() {
      if (this.formValues.detailPekerjaan.uraianPekerjaan !== null) {
        this.messageUraianPekerjaan.panjang =
          this.formValues.detailPekerjaan.uraianPekerjaan?.length || 0;

        const lines =
          this.formValues.detailPekerjaan.uraianPekerjaan.split("\n");

        let totalLines = 0;

        for (let line of lines) {
          const lineParts = Math.ceil(line.length / this.maxCharsPerLine);
          totalLines += lineParts;
        }

        this.messageUraianPekerjaan.lineCount = totalLines;
      }

      if (this.formValues.persyaratanKhusus.tindakPencegahan !== null) {
        this.messageTindakPencegahan.panjang =
          this.formValues.persyaratanKhusus.tindakPencegahan.length || 0;

        const lines =
          this.formValues.persyaratanKhusus.tindakPencegahan.split("\n");

        let totalLines = 0;

        for (let line of lines) {
          const lineParts = Math.ceil(line.length / this.maxCharsPerLine);
          totalLines += lineParts;
        }

        this.messageTindakPencegahan.lineCount = totalLines;
      }
    },
  },
};
</script>

<style scoped>
input[type="radio"] {
  appearance: none;
  background-color: #fff;
  width: 15px;
  height: 15px;
  border: 2px solid #ccc;
  border-radius: 2px;
  display: inline-grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  width: 10px;
  height: 10px;
  transform: scale(0);
  transform-origin: bottom left;
  background-color: #fff;
  clip-path: polygon(13% 50%, 34% 66%, 81% 2%, 100% 18%, 39% 100%, 0 71%);
}

input[type="radio"]:checked::before {
  transform: scale(1);
}

input[type="radio"]:checked {
  background-color: #0075ff;
  border: 2px solid #0075ff;
}
</style>
